import { useIntl } from 'react-intl';

import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import CommentIcon from '@atlaskit/icon/core/comment';
import TimelineIcon from '@atlaskit/icon/core/timeline';
import { token } from '@atlaskit/tokens';

import { LoggedInJiraWhiteTemplateUpgradeEligibleUser } from '../components/logged-in-jira-upgrade-eligible-user';

export const LoggedInJiraPremiumUpgradeEligibleUser = () => {
	const { formatMessage } = useIntl();

	const valueProps = [
		{
			icon: (
				<AtlassianIntelligenceIcon
					color={token('color.icon.brand')}
					label="Atlassian Intelligence"
				/>
			),
			heading: formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Title',
				defaultMessage: 'Atlassian Intelligence (AI)',
			}),
			body: formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Body',
				defaultMessage: 'AI-powered features to help teams create value faster',
			}),
		},
		{
			icon: <TimelineIcon color={token('color.icon.brand')} label="Timeline" />,
			heading: formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title',
				defaultMessage: 'Advanced planning',
			}),
			body: formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body',
				defaultMessage: 'Plan work and track progress across multiple teams and projects',
			}),
		},
		{
			icon: <CommentIcon color={token('color.icon.brand')} label="Comment" />,
			heading: formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Title',
				defaultMessage: 'Premium support',
			}),
			body: formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Body',
				defaultMessage: "Get 24/7 support from Atlassian's team of experts",
			}),
		},
	];

	return (
		<LoggedInJiraWhiteTemplateUpgradeEligibleUser
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudPremium',
				defaultMessage: 'Cloud Premium',
			})}
			textHeading={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumUpgradeTitle',
				defaultMessage: 'Upgrade to the Premium plan',
			})}
			textBody={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswUpgradeBody',
				defaultMessage:
					'Get a free 30-day trial of Jira Premium for unlimited users, unlimited storage, and much more. Cancel anytime.',
			})}
			valuePropsHeading={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumBulletIntro',
				defaultMessage: 'The Premium plan also includes:',
			})}
			valueProps={valueProps}
		/>
	);
};
